import { ChangeNameFormDataI } from 'components/base/ChangeNameModal';
import { ValidationSet } from '../../../../types/interface';
import { commonValidations } from '../validations';

export const ChangeNameValidationSet: ValidationSet<ChangeNameFormDataI> = {
  first_name: commonValidations.firstName,
  last_name: commonValidations.lastName
};
